// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dad884e9","455":"fa2d5eac","977":"b307a823"}[chunkId] + ".chunk.js";
};